/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import { useMutation } from '@apollo/client' // Npm: Apollo client for handling graphql request.
import { useToast } from '@chakra-ui/react' // Npm: Chakra UI toast component.
import { useSelector } from 'react-redux' // Npm: Redux selector hook.


/*
 * PACKAGES
 */
import SystemCard from 'components/SystemCard'
import RestartConfirmationModal from 'components/RestartConfirmationModal'


/*
 * GRAPHS
 */
import RestartRemoterServerMutation from './__mutation__/index.dbserver.restart'



/*
 * COMPONENT
 */
const DbServerInfo = () => {
  // Hook assignment.
  const toast = useToast()
  const [modalOpen, setModalOpen] = React.useState(false)

  // Get data from Redux store instead of subscription.
  const { data: dbServerData, error: dbServerError, loading: isLoading } = useSelector(
    (state) => state.SystemInfo.remote
  )

  // Mutation to restart DB server.
  const [MutationRestartDbServer, MutationRestartDbServerResponse] = useMutation(
    RestartRemoterServerMutation,
    {
      'onCompleted': (res) => {
        // Check if restart was successful.
        const success = res?.RestartRemoterServer?.success
        toast({
          'title': success ? 'DB Server Restarted' : 'Restart Failed',
          'description': res?.RestartRemoterServer?.message || '',
          'status': success ? 'success' : 'error',
          'duration': 5000,
          'isClosable': true,
        })
      },
      'onError': (error) => {
        // Show error toast.
        toast({
          'title': 'DB Server restart failed',
          'description': error.message,
          'status': 'error',
          'duration': 5000,
          'isClosable': true,
        })
      },
    }
  )

  // Modal handlers.
  const openModal = React.useCallback(() => setModalOpen(true), [])
  const closeModal = React.useCallback(() => setModalOpen(false), [])
  const handleConfirmRestart = React.useCallback(() => {
    closeModal()
    MutationRestartDbServer()
  }, [closeModal, MutationRestartDbServer])

  // Return component.
  return (
    <>
      <SystemCard
        title="Database Server"
        data={dbServerData}
        serverType="db"
        onRestart={openModal}
        isRestarting={MutationRestartDbServerResponse.loading}
        fetchError={dbServerError}
        isFetching={isLoading}
      />

      <RestartConfirmationModal
        isOpen={modalOpen}
        onClose={closeModal}
        onConfirm={handleConfirmRestart}
        message="Are you sure you want to restart the Database server?"
      />
    </>
  )
}


/*
 * EXPORTS
 */
export default DbServerInfo
